import React, { Component } from 'react';
import { Image, Col, Row, Container } from 'react-bootstrap';
import Arrow from '../../../img/Arrow.svg'
import Comercio from '../../../img/NewPNG/Comercio.png'
import Pagos from '../../../img/NewPNG/Pagos.png'
import Translate from '../../../../../translate'
import './index.css'

class Unete extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <div className='afiliar-background section-container' id='afiliar'>
        <div className='afiliar-outter'>
          <Container>
            <Row>
              <Col md={12} className='sectionColumnsTitles' style={{marginBottom: '30px'}}>
                <div className='sectionDivTitles'>
                  <p className='title-section'>{Translate[this.props.lan].landing3.seccion8.titulo}</p>
                  <p className='subtitle-section'>{Translate[this.props.lan].landing3.seccion8.subtitulo}</p>
                </div>
              </Col>
              <Col>
                <div>
                  <Row>
                    <Col sm={12} md={12} lg={5} className='afiliar-conatiner'>
                      <Col xs={10} md={10} lg={9} >
                        <p className='link' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[this.props.lan].landing3.seccion8.comercio} <Image src={Arrow} style={{marginLeft: '5px'}} width="25px" /></p>
                        <p className='afiliar-text'>{Translate[this.props.lan].landing3.seccion8.comercioDesc}</p>
                      </Col>
                      <Col xs={2} md={2} lg={3}  className='afiliarimage-container'>
                        <Image src={Comercio}/>
                      </Col>
                    </Col>
                    <Col sm={12} md={12} lg={2} style={{minHeight:30}}/>
                    <Col sm={12} md={12} lg={5} className='afiliar-conatiner'>
                      <Col xs={10} md={10} lg={9}>
                        <p className='link' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[this.props.lan].landing3.seccion8.criptopagos} <Image src={Arrow} style={{marginLeft: '5px'}} width="25px" /></p>
                        <p className='afiliar-text'>{Translate[this.props.lan].landing3.seccion8.criptopagosDesc}</p>
                      </Col>
                      <Col xs={2} md={2} lg={3}  className='afiliarimage-container'>
                        <Image src={Pagos}/>
                      </Col>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default Unete
